@if (isBrowser) {
  <c-carousel [dark]="true" transition="slide">
    <c-carousel-indicators></c-carousel-indicators>
    <c-carousel-inner>
      <c-carousel-item *ngFor="let slide of slides">
        <img
          [src]="slide.src | translate"
          [alt]="slide.alt | translate"
          [title]="slide.title | translate"
          class="carousel-img"
          draggable="false"
          loading="lazy"
          (contextmenu)="$event.preventDefault()"
        />
      </c-carousel-item>
    </c-carousel-inner>
    <c-carousel-control caption="Previous" direction="prev"></c-carousel-control>
    <c-carousel-control caption="Next" direction="next"></c-carousel-control>
  </c-carousel>
}
